export enum OffsetModeViewEnum {
    Ticks = 0,
    TicksFractionalForForex = 1,
    Points = 2
}
